<template>
    <el-form :model="giftBagSetting"
             v-form
             editAction="dbtCard/saveRightsCardPackage.action"
             addAction= "dbtCard/saveRightsCardPackage.action"
             selectAction="dbtCard/selectRightsCardPackage.action"
             @onAdded="onSaved"
             @onEdited="onSaved"
             :rules="rules" ref="ruleForm" label-width="140px" class="demo-ruleForm">
      <!--  <el-form-item label="名称" prop="packageName" >
            <el-input v-model="giftBagSetting.packageName" placeholder="请输入名称"></el-input>
        </el-form-item>
        <el-form-item label="介绍" prop="packageDesc">
            <el-input v-model="giftBagSetting.packageDesc"  placeholder="请输入介绍"></el-input>
        </el-form-item>
        <el-form-item label="云服务次数" prop="rightsCardNum">
            <el-input v-model="giftBagSetting.rightsCardNum" type="number" min="0" step="1" placeholder="请输入云服务次数"></el-input>
        </el-form-item>-->
        <el-form-item label="升级门槛" prop="retailPrice">
            <el-input v-model="giftBagSetting.retailPrice" type="number" min="0" step="0.01"  placeholder="请输入价格"></el-input>
        </el-form-item>
        <el-form-item label="经纪人奖励" prop="agentProfit">
            <el-input v-model="giftBagSetting.agentProfit" type="number" min="0" step="0.01"  placeholder="请输入经纪人奖励"></el-input>
        </el-form-item>
        <el-form-item label="合伙人奖励" prop="dealerProfit">
            <el-input v-model="giftBagSetting.dealerProfit" type="number" min="0"  step="0.01" placeholder="请输入合伙人奖励"></el-input>
            <p style="color:gray">若合伙人直拓，则获得经纪人奖励+合伙人奖励</p>
        </el-form-item>
        <el-form-item>
            <el-button type="primary"  >立即保存</el-button>
        </el-form-item>
    </el-form>
</template>
<script>
import TableTemplate from '@/components/TableTemplate'
export default {
  name: 'gift-bag-setting',
  components: { TableTemplate },
  data () {
    let checkInt = (rule, value, callback) => {
      if (value < 0) {
        return callback(new Error('请填写大于0的整数'))
      }

      let match = (value + '').match(/^\d+(\.\d{0})?$/)
      if (!match) {
        return callback(new Error('只能为整数哦！'))
      }

      callback()
    }

    let checkDecimal = (rule, value, callback) => {
      if (value < 0) {
        return callback(new Error('请填写大于0的数值'))
      }

      let match = (value + '').match(/^\d+(\.\d{1,2})?$/)
      if (!match) {
        return callback(new Error('小数点只能保留两位哦！'))
      }

      callback()
    }

    let checkAgentProfit = (rule, value, callback) => {
      let retailPrice = parseFloat(this.giftBagSetting.retailPrice)
      let dealerProfit = parseFloat(this.giftBagSetting.dealerProfit)
      let agentProfit = parseFloat(this.giftBagSetting.agentProfit)

      let totalPrice = dealerProfit + agentProfit
      if (totalPrice > retailPrice) {
        return callback(new Error('经纪人奖励和合伙人奖励总金额(' + totalPrice.toFixed(2) + ')不能大于升级门槛价格(' + retailPrice.toFixed(2) + ')'))
      }
      callback()
    }

    return {
      disabled: true,
      giftBagSetting: {
        id: 1,
        packageName: '云服务包',
        packageDesc: '升级经纪人门槛',
        rightsCardNum: 0,
        retailPrice: null,
        agentProfit: null,
        dealerProfit: null
      },
      rules: {
        packageName: [
          { required: true, message: '请输入名称', trigger: 'blur' }
        ],
        packageDesc: [
          { required: true, message: '请输入介绍', trigger: 'blur' }
        ],
        rightsCardNum: [
          { required: true, message: '请输入云服务次数', trigger: 'blur' },
          { validator: checkInt, trigger: 'blur' }
        ],
        retailPrice: [
          { required: true, message: '请输入价格', trigger: 'blur' },
          { validator: checkDecimal, trigger: 'blur' }
        ],
        agentProfit: [
          { required: true, message: '请输入经纪人奖励', trigger: 'blur' },
          { validator: checkAgentProfit, trigger: 'blur' },
          { validator: checkDecimal, trigger: 'blur' }
        ],
        dealerProfit: [
          { required: true, message: '请输入合伙人奖励金额', trigger: 'blur' },
          { validator: checkAgentProfit, trigger: 'blur' },
          { validator: checkDecimal, trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    onSaved () {
      this.$message({ type: 'success', message: '操作成功！' })
      return true
    },
    onSelectInfo (dataInfo) {
      if (dataInfo.datas) {
        this.disabled = true
      } else {
        this.disabled = false
      }
    }
  }
}
</script>
